var cov_ouhppcizu = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/scrollBehavior.js",
      hash = "6cab939ca29955b43cb7fb4ad0984b8fcdf2b17a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/scrollBehavior.js",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 16
        },
        end: {
          line: 2,
          column: 20
        }
      },
      "1": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "2": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 53
        }
      },
      "3": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 53
        }
      },
      "4": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 16
        }
      },
      "5": {
        start: {
          line: 8,
          column: 26
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "6": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 32
        }
      },
      "7": {
        start: {
          line: 9,
          column: 26
        },
        end: {
          line: 9,
          column: 32
        }
      },
      "8": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 49
        }
      },
      "9": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 44
        }
      },
      "10": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "11": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 47
        }
      },
      "12": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 18
        }
      },
      "13": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "14": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 54
        }
      },
      "15": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 56
        }
      },
      "16": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "17": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 59
        }
      },
      "18": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 61
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 16
          },
          end: {
            line: 4,
            column: 17
          }
        },
        loc: {
          start: {
            line: 4,
            column: 22
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 26
          },
          end: {
            line: 8,
            column: 27
          }
        },
        loc: {
          start: {
            line: 8,
            column: 32
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 28
          },
          end: {
            line: 14,
            column: 29
          }
        },
        loc: {
          start: {
            line: 14,
            column: 34
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 30
          },
          end: {
            line: 19,
            column: 31
          }
        },
        loc: {
          start: {
            line: 19,
            column: 36
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 19
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 10
          }
        },
        loc: {
          start: {
            line: 22,
            column: 15
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 53
          }
        }, {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 53
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 32
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 32
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var htmlDom;
var lastStyle = (cov_ouhppcizu.s[0]++, null);
cov_ouhppcizu.s[1]++;

var getHtml = function getHtml() {
  cov_ouhppcizu.f[0]++;
  cov_ouhppcizu.s[2]++;

  if (!htmlDom) {
    cov_ouhppcizu.b[0][0]++;
    cov_ouhppcizu.s[3]++;
    htmlDom = document.body.parentElement;
  } else {
    cov_ouhppcizu.b[0][1]++;
  }

  cov_ouhppcizu.s[4]++;
  return htmlDom;
};

cov_ouhppcizu.s[5]++;

var setScrollBehavior = function setScrollBehavior() {
  cov_ouhppcizu.f[1]++;
  cov_ouhppcizu.s[6]++;

  if (lastStyle !== null) {
    cov_ouhppcizu.b[1][0]++;
    cov_ouhppcizu.s[7]++;
    return;
  } else {
    cov_ouhppcizu.b[1][1]++;
  }

  cov_ouhppcizu.s[8]++;
  lastStyle = getHtml().style.overscrollBehaviorX;
  cov_ouhppcizu.s[9]++;
  htmlDom.style.overscrollBehaviorX = 'none';
};

cov_ouhppcizu.s[10]++;

var resetScrollBehavior = function resetScrollBehavior() {
  cov_ouhppcizu.f[2]++;
  cov_ouhppcizu.s[11]++;
  htmlDom.style.overscrollBehaviorX = lastStyle;
  cov_ouhppcizu.s[12]++;
  lastStyle = null;
};

cov_ouhppcizu.s[13]++;
export var banOverScrollX = function banOverScrollX(el) {
  cov_ouhppcizu.f[3]++;
  cov_ouhppcizu.s[14]++;
  el.addEventListener('mouseenter', setScrollBehavior);
  cov_ouhppcizu.s[15]++;
  el.addEventListener('mouseleave', resetScrollBehavior);
  cov_ouhppcizu.s[16]++;
  return function () {
    cov_ouhppcizu.f[4]++;
    cov_ouhppcizu.s[17]++;
    el.removeEventListener('mouseenter', setScrollBehavior);
    cov_ouhppcizu.s[18]++;
    el.removeEventListener('mouseleave', resetScrollBehavior);
  };
};